























































































































































import Vue from "vue";
import {EntityService} from "@/services/entity.service";
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators';
const entityService = new EntityService()
import { VueEditor } from "vue2-editor";

export default Vue.extend({
	name: 'InstrumentoEdit',
	mixins: [validationMixin],
	components: { VueEditor },
	validations: {
		form: {
			titulo: {required, maxLength: maxLength(150)},
			colorTitulo: {required, maxLength: maxLength(150)},
			colorFondo: {required, maxLength: maxLength(150)},
			colorLetra: {required, maxLength: maxLength(150)},
			imagen: {required},
		}
	},
	props: ['value', 'editEntity'],
	data: () => ({
		entity: 'instrumentos',
		isLoading: false,
		uploadFileUrl: 'uploadfile',
		form: {
			id: 0,
			titulo: '',
			descripcion: '',
			colorTitulo: '',
			colorFondo: '',
			colorLetra: '',
			imagen: '',
			link1: '',
			link2: '',
			link3: '',
			link4: '',
			ordenMobile: '',
		}
	}),
	async created() {
		this.form = {
			id: this.editEntity.id,
			titulo: this.editEntity.titulo,
			descripcion: this.editEntity.descripcion,
			colorTitulo: this.editEntity.colorTitulo,
			colorFondo: this.editEntity.colorFondo,
			colorLetra: this.editEntity.colorLetra,
			imagen: this.editEntity.imagen,
			link1: this.editEntity.link1,
			link2: this.editEntity.link2,
			link3: this.editEntity.link3,
			link4: this.editEntity.link4,
			ordenMobile: this.editEntity.ordenMobile
		}
	},
	methods: {
		toggleModal (value: boolean) {
			this.$emit('input', value)
		},
		async save() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				this.isLoading = true
				await entityService.updateEntity(this.entity, this.form)
				this.isLoading = false
				this.$emit('input', false)
			}
		},
		getError: function (element: string) {
			const obj = this.$v['form'][element] || {$error: ''}
			if (obj.$error) return 'Campo requerido'
			return;
		},
		async uploadImagen (file: File) {
			if (!file) return
			// if (!['MP3', 'FLAC', 'WAV'].includes(this.getExtension(file.name).toUpperCase())) {
			// 	alert('Archivo inválido')
			// 	this.form.file = null
			// 	this.filename = null
			// }
			this.isLoading = true
			const response = await entityService.uploadFile(this.entity, this.uploadFileUrl, file)
			if (response.web) this.form.imagen = response.web
			this.isLoading = false
		},
		async uploadLink1 (file: File) {
			if (!file) return
			// if (!['MP3', 'FLAC', 'WAV'].includes(this.getExtension(file.name).toUpperCase())) {
			// 	alert('Archivo inválido')
			// 	this.form.file = null
			// 	this.filename = null
			// }
			this.isLoading = true
			const response = await entityService.uploadFile(this.entity, this.uploadFileUrl, file)
			if (response.web) this.form.link1 = response.web
			this.isLoading = false
		},
	},
})
